import type { ButtonHTMLAttributes } from "react";
import cx from "classnames";

import { Icon } from "common/ui/Icon";
import { Stack } from "common/ui/Stack";
import { Spinner } from "common/ui/Spinner";

import styles from "./Button.module.scss";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant:
    "primary"
    | "secondary"
    | "destructive"
    | "secondaryDestructive"
    | "tertiary"
    | "document"
    | "inline"
    | "add"
    | "roundedPrimary"
    | "roundedSecondary",
  noSubmit?: boolean,
  fullWidth?: boolean,
  noIndent?: boolean,
  isLoading?: boolean,
  showNotification?: boolean,
}

export function Button({
  variant,
  noSubmit,
  fullWidth,
  children,
  className,
  noIndent = false,
  isLoading,
  disabled,
  showNotification,
  ...rest
}: Props) {
  return (
    variant === "document" ? (
      <Stack gap={4} alignItems="center">
        {isLoading && (
          <Spinner width={10} height={10} />
        )}
        <Icon icon="paperclip" />
        <button
          className={cx(styles.Button, styles.document, className)}
          type="button"
          disabled={disabled || isLoading}
          { ...rest }
        >
          {children}
        </button>
      </Stack>
    ) : (
      <button
        className={cx(styles.Button, className, {
          [styles.primary]: variant === "primary",
          [styles.secondary]: variant === "secondary",
          [styles.destructive]: variant === "destructive",
          [styles.secondaryDestructive]: variant === "secondaryDestructive",
          [styles.tertiary]: variant === "tertiary",
          [styles.noIndent]: noIndent,
          [styles.fullWidth]: fullWidth,
          [styles.inline]: variant === "inline",
          [styles.add]: variant === "add",
          [styles.rounded]: variant === "roundedPrimary" || variant === "roundedSecondary",
          [styles.roundedPrimary]: variant === "roundedPrimary",
          [styles.roundedSecondary]: variant === "roundedSecondary",
          [styles.notification]: showNotification,
        })}
        type={noSubmit ? "button" : "submit"}
        disabled={disabled || isLoading}
        { ...rest }
      >
        {isLoading &&
          <Spinner
            className={styles.Spinner}
            width={20}
            height={20}
          />
        }
        {variant === "add" && (
          <Icon icon="add" />
        )}
        {children}
      </button>
    )
  )
}

